import axios from "axios";
import { API_CONFIG } from "./config";

export const vocApi = axios.create({
  baseURL: API_CONFIG.VOC_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// VOC API 타입
export interface VocSubmitData {
  title: string;
  content: string;
  name: string;
  password: string;
  phoneNumber: string;
  companyName: string;
  serviceSortation: string;
  email: string;
}

export interface VocSubmitResponse {
  no: number;
  message?: string;
}

export interface VocCheckData {
  contact: string;
  password: string;
}

// VOC API 함수
export const vocSubmit = async (
  data: VocSubmitData,
  file?: File | null
): Promise<VocSubmitResponse> => {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("content", data.content);
  formData.append("name", data.name);
  formData.append("password", data.password);
  formData.append("phoneNumber", data.phoneNumber);
  formData.append("companyName", data.companyName);
  formData.append("serviceSortation", data.serviceSortation);
  formData.append("email", data.email);

  if (file) {
    formData.append("fileName", file.name);
    formData.append("data", file);
  } else {
    formData.append("fileName", "");
    formData.append("data", new Blob());
  }

  const response = await vocApi.post("/vocCreate", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getVocDetail = async (no: string, password: string, phoneNumber: string) => {
  const response = await vocApi.get(`/vocSearch`, {
    params: { password, no, phoneNumber },
  });
  return response.data;
};

export const vocFileDownload = async (no: number, fileName?: string): Promise<void> => {
  try {
    const response = await vocApi.get(`/download?no=${no}`, {
      responseType: "blob",
    });

    const contentType = response.headers["content-type"] || "application/octet-stream";
    const blob = new Blob([response.data], { type: contentType });

    // Content-Disposition 헤더에서 파일명 추출
    let downloadName = fileName || "다운로드";
    const disposition = response.headers["content-disposition"];
    if (disposition) {
      const fileNameMatch = disposition.match(/filename\*=UTF-8''([^;\n]+)/);
      if (fileNameMatch && fileNameMatch[1]) {
        downloadName = decodeURIComponent(fileNameMatch[1]);
      } else {
        const secondMatch = disposition.match(/filename="?([^;\n"]+)"?/);
        if (secondMatch && secondMatch[1]) {
          downloadName = secondMatch[1];
        }
      }
    }

    const fileObjectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = fileObjectUrl;
    a.download = downloadName;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(fileObjectUrl);
    }, 60000);
    a.remove();
  } catch (error) {
    console.error("파일 다운로드 오류:", error);
    throw error;
  }
};
